import { WidgetAnimationScriptRenderer } from "./shared/rendering/widget-animation-script.renderer";
import { SectionScrollEffectScriptRenderer } from "./shared/rendering/section-scroll-effect-script.renderer";
import { HeaderSectionAreaScriptRenderer } from "./shared/rendering/header-section-area-script.renderer";
import { PopupScriptRenderer } from "./shared/rendering/popup-script.renderer";
import { AnalyticsScriptRenderer } from "./shared/rendering/analytics-script.renderer";

export abstract class ContentRendererBase {

    private readonly widgetAnimationScriptRenderer: WidgetAnimationScriptRenderer;
    private readonly sectionScrollEffectScriptRenderer: SectionScrollEffectScriptRenderer;
    private readonly headerSectionAreaScriptRenderer: HeaderSectionAreaScriptRenderer;
    private readonly popupScriptRenderer: PopupScriptRenderer;
    private readonly analyticsScriptRenderer: AnalyticsScriptRenderer;

    public constructor() {
        this.widgetAnimationScriptRenderer = new WidgetAnimationScriptRenderer();
        this.sectionScrollEffectScriptRenderer = new SectionScrollEffectScriptRenderer();
        this.headerSectionAreaScriptRenderer = new HeaderSectionAreaScriptRenderer();
        this.popupScriptRenderer = new PopupScriptRenderer();
        this.analyticsScriptRenderer = new AnalyticsScriptRenderer();
    }

    protected addWidgetAnimationScript(doc: Document): void {
        this.widgetAnimationScriptRenderer.renderCommon(doc);
    }

    protected addSectionScrollEffectScript(doc: Document): void {
        this.sectionScrollEffectScriptRenderer.renderCommon(doc);
    }

    protected addHeaderSectionAreaScript(doc: Document): void {
        this.headerSectionAreaScriptRenderer.renderCommon(doc);
    }

    protected addPopupScript(doc: Document): void {
        this.popupScriptRenderer.renderCommon(doc);
    }

    protected addAnalyticsScript(doc: Document): void {
        this.analyticsScriptRenderer.renderCommon(doc);
    }

}
